var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Handler } from '@pawgame/game-library';
import { AsyncPanel, View } from '@pawgame/laya-game-sdk';
import { LoadingPanel } from '../modules/loading/LoadingPanel';
import { showAlert } from './Alert';
export class GAsyncPanel extends AsyncPanel {
    load() {
        const _super = Object.create(null, {
            load: { get: () => super.load }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._isLoading) {
                View.togglePanel(LoadingPanel, 1);
            }
            yield _super.load.call(this);
        });
    }
    onResReady() {
        View.togglePanel(LoadingPanel, 0);
        super.onResReady();
    }
    onResError() {
        View.togglePanel(LoadingPanel, 0);
        showAlert('提示', '哎呀，加载失败了，请重试', Handler.create(this, () => {
            this.load();
        }));
    }
}
//# sourceMappingURL=AsyncPanel.js.map